import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { UserProvider } from "./context/UserContext";
import LandingPage from './landingComponents/LandingPage';
import CartPage from './landingComponents/CartPage';
import RegistrationPage from './landingComponents/Register';
import CategorySection from './landingComponents/CategorySection';
import Login from './landingComponents/Login';
import Profile from './landingComponents/Profile';
import MyCourses from './landingComponents/MyCourses';
import IndDetails from './landingComponents/IndDetails';
import PipDetails from './landingComponents/PipDetails';
import PaymentDetails from './landingComponents/PaymentDetails';
import PaymentHistory from './landingComponents/PaymentHistory';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import PrivateRoute from './Route/PrivateRoute';
import InactivityHandler from './Route/InactivityHandler';
import Custom404 from './landingComponents/Custom404';
import PipRegister from './landingComponents/PipRegister';
import GroupRegister from './landingComponents/GroupRegister';
import ConfirmationList from './landingComponents/ConfirmationList';
import ConformationPayList from './landingComponents/ConformationPayList';
import '@fortawesome/fontawesome-free/css/all.min.css';
import BankDetails from './landingComponents/BankDetails';
import ScrollToTop from './helperComponents/ScrollToTop';
import { TransactionProvider } from './context/TransactionContext';
import Report from './landingComponents/Report';
import PaymentTest from './landingComponents/PaymentTest';
import OverAllReport from './landingComponents/OverAllReport';
import CoursePurchaseSuccess from './landingComponents/PaySuccess';
import PayFailed from './landingComponents/PayFailed';
import PasswordReset from './landingComponents/PasswordReset';
import OverAllPIPReport from './landingComponents/OverAllPIPReport';
import PricingPage from './landingComponents/PricingPage';
import SetPricing from './landingComponents/SetPricing';
import TermsConditions from './landingComponents/TermsConditions';
import ChatbotIframe from './helperComponents/ChatbotIframe';
import ChatbotPortal from './helperComponents/ChatbotPortal';
import AnalyticsTracker from './utilitity/Analytics';


const Layout = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/cart" element={<CartPage data="Your Shopping Cart" image="CartImages" />} />
      <Route path="/register" element={<RegistrationPage />} />
      <Route path="/category/:id" element={<CategorySection />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pass-reset/:id" element={<PasswordReset />} />
      {/* <Route path="/all-report" data="Reports" image="report" element={<OverAllReport />} /> */}
      <Route path="/payment-test" element={<PaymentTest />} />
      <Route path="/terms" element={<TermsConditions />} />
      {/* <Route path="/pricing" element={<PricingPage />} />
        <Route path="/set-price" element={<SetPricing />} /> */}




      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/profile" element={<Profile />} />
        <Route path="/my-courses" element={<MyCourses data="My Courses" image="Book" />} />
        <Route path="/ind-details" element={<IndDetails data="Individual Details" image="userDetails" />} />
        <Route path="/pip-details" element={<PipDetails data="PIP Details" image="userDetails" />} />
        <Route path="/all-report" element={<OverAllReport data="Report" image="report" />} />
        <Route path="/all-reports" element={<OverAllPIPReport data="Report" image="report" />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/set-price" element={<SetPricing />} />
        <Route path="/payment-details" element={<PaymentDetails title="Transaction Details" image="payment" />} />
        <Route path="/payment-history" element={<PaymentHistory data="Payment History" image="payment" />} />
        <Route path="/add-Pip" element={<PipRegister />} />
        <Route path="/report" element={<Report />} />
        <Route path="/success" element={<CoursePurchaseSuccess />} />
        <Route path="/failed" element={<PayFailed />} />
        <Route path="/group-register" element={
          <TransactionProvider>
            <GroupRegister />
          </TransactionProvider>
        } />
        <Route path="/group-list" element={
          <TransactionProvider>
            <ConfirmationList />
          </TransactionProvider>
        } />
        <Route path="/pay-group-list/:transactionId" element={<ConformationPayList />} />
        <Route path="/bank-details" element={<BankDetails />} />

      </Route>
      <Route path="*" element={<Custom404 />} />
    </Routes>
  )
}
function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        {/* <InactivityHandler> */}
        <ScrollToTop />
        <AnalyticsTracker>
          <Layout />
        </AnalyticsTracker>


        {/* <ChatbotPortal /> */}
        {/* <ChatbotIframe/> */}
        {/* </InactivityHandler> */}
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
